// Typy produktów magazynowych
export const STORAGE_ITEM_TYPES = {
  MDF: 'MDF',
};

// Array do selecta
export const STORAGE_ITEM_TYPES_ARRAY = Object.values(STORAGE_ITEM_TYPES);
